import { create } from "zustand";
import api from "../../services/api";

const useProductStore = create((set) => ({
  products: [],
  loading: false,
  error: null,

  getAllProducts: async () => {
    set({ loading: true, error: null });
    try {
      const response = await api.get("/products");
      set({ products: response.data, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  addProduct: (product) => {
    set((state) => ({ products: [...state.products, product] }));
  },

  updateProduct: (id, data) => {
    set((state) => ({
      products: state.products.map((product) => {
        if (product.id === id) {
          const size = data.size;

          console.log("size: ", size);
          console.log("type of size: ", typeof size);
          if (typeof size === "string") {
            const sizeInM3 = size
              .split("x")
              .reduce((acc, val) => acc * Number(val), 1);

            data.size = sizeInM3;
          }

          return {
            ...product,
            ...data,
            id,
            ii: data.ii / 100,
            ipi: data.ipi / 100,
            pis: data.pis / 100,
            cofins: data.cofins / 100,
            icms: data.icms / 100,
          };
        }

        return product;
      }),
    }));
  },

  removeProduct: (id) => {
    set((state) => ({
      products: state.products.filter((product) => product.id !== id),
    }));
  },
}));

export default useProductStore;
